import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import ABSIcon from '../../ABSIcon';
import ABSSelect from '../../ABSSelect';
import ABSField from '../../ABSField';
import { DatePicker as AntdDatePicker } from 'antd';
import { IPickerProps } from '../interface';
import { endMax, getYearFieldData } from '../utils';
import {
  locale,
  moment,
  isSame,
  formatMonth,
  ForMatter
} from '../../../utils/momentUtils';
import emitter, { EventName } from '../../../utils/eventUtils';
import './index.less';

const { MonthPicker } = AntdDatePicker;

const yearOptions = getYearFieldData();

const DatePicker: React.FC<IPickerProps> = props => {
  const pick: any = useRef(null);

  useEffect(() => {
    emitter.addListener(EventName.hideDropDown, handleScroll);
    return () => {
      emitter.removeListener(EventName.hideDropDown, handleScroll);
    };
  }, []);

  function handleScroll() {
    if (pick && pick.current && pick.current.picker) {
      pick.current.picker.setState({ open: false });
    }
  }
  const {
    value,
    defaultValue,
    dropdownClassName,
    placeholder = '请选择日期',
    onChange,
    // field
    className,
    title,
    titleClassName,
    required,
    labelWidth,
    contentWidth,
    removePaddingLeft,
    removeMarginBottom,
    isVertical,
    contentClassName,
    result,
    desc,
    // date && month
    picker,
    format,
    disabledDate,
    // month
    open,
    renderExtraFooter,
    onOpenChange,
    isFlex
  } = props;

  const pickerProps = {
    open,
    dropdownClassName: classnames('abs-calendar-picker', dropdownClassName, {
      'has-error': !result.pass
    }),
    placeholder,
    locale,
    format,
    disabledDate,
    onChange,
    onOpenChange,
    renderExtraFooter,
  };

  if (open === undefined) {
    delete pickerProps.open;
  }

  // 更新后删除year
  let defaultValues: any = defaultValue || undefined;
  if (defaultValue && picker !== 'year' && typeof value === 'string') {
    defaultValues = moment(defaultValue);
  }
  let values: any = value || undefined;
  if (picker !== 'year' && typeof value === 'string') {
    values = moment(value);
  }
  // 判断是否是月份中今天的操作
  let isToday = false;
  if (
    (values && formatMonth(values, ForMatter.month) === endMax) ||
    (defaultValues && formatMonth(defaultValues, ForMatter.month) === endMax)
  ) {
    isToday = true;
  }

  if (picker === 'year') {
    const { disabled, options, rules, refs } = props;
    return (
      <ABSSelect
        title={title}
        titleClassName={titleClassName}
        contentClassName={contentClassName}
        required={required}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className={className}
        dropdownClassName={dropdownClassName}
        onChange={onChange}
        disabled={disabled}
        selectOptions={options || yearOptions}
        ref={refs}
        rules={rules}
        labelWidth={labelWidth}
        contentWidth={contentWidth}
        isVertical={isVertical}
        desc={desc}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        isFlex={isFlex}
      />
    );
  }

  let item = {};

  switch (picker) {
    case 'month': {
      item = (
        <MonthPicker
          {...pickerProps}
          value={isToday ? moment() : values}
          defaultValue={isToday ? moment() : defaultValues}
          suffixIcon={<ABSIcon type="attendance-m" />}
          allowClear={false}
          ref={pick}
          getCalendarContainer={isFlex ? (triggerNode: any) => triggerNode.parentNode : undefined}
        />
      );
      break;
    }
    default:
      item = (
        <AntdDatePicker
          {...pickerProps}
          value={values}
          defaultValue={defaultValues}
          showToday={false}
          allowClear={false}
          suffixIcon={<ABSIcon type="attendance-m" />}
          dateRender={current => {
            const date = isSame(current) ? '今' : current.date().toString();
            return <div className="ant-calendar-date">{date}</div>;
          }}
          ref={pick}
          getCalendarContainer={isFlex ? (triggerNode: any) => triggerNode.parentNode : undefined}
        />
      );
      break;
  }
  const clazs = classnames('abs-calendar', className);
  return (
    <ABSField
      result={result}
      className={clazs}
      title={title}
      titleClassName={titleClassName}
      contentClassName={contentClassName}
      required={required}
      labelWidth={labelWidth}
      contentWidth={contentWidth || 240}
      removePaddingLeft={removePaddingLeft}
      removeMarginBottom={removeMarginBottom}
      desc={desc}
      isVertical={isVertical}
    >
      {item}
    </ABSField>
  );
};

export default React.memo(DatePicker);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/DatePicker/index.tsx